var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteclose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27594 24.9325C1.68756 24.9672 1.10887 24.7693 0.661922 24.3806C-0.219501 23.4836 -0.219501 22.0349 0.661922 21.1379L19.9622 1.613C20.879 0.745176 22.3175 0.793418 23.1754 1.72084C23.9511 2.55951 23.9963 3.84856 23.2812 4.7407L3.86721 24.3806C3.42607 24.7637 2.85662 24.9612 2.27594 24.9325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5536 24.9327C20.9572 24.9301 20.3857 24.6906 19.9622 24.2657L0.661861 4.74073C-0.154733 3.77604 -0.0437125 2.32424 0.909878 1.49807C1.76098 0.760734 3.01619 0.760734 3.86722 1.49807L23.2812 21.023C24.1978 21.8911 24.2451 23.3464 23.3871 24.2736C23.3529 24.3105 23.3177 24.3462 23.2812 24.3807C23.046 24.5876 22.7713 24.7434 22.4741 24.8383C22.1769 24.9333 21.8636 24.9654 21.5536 24.9327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteclose);
export default __webpack_public_path__ + "static/media/whiteclose.4475c3a9cb9a1b80fb645522f5ea7b2c.svg";
export { ForwardRef as ReactComponent };